export const experienceData = [
  // {
  //   id: 3,
  //   company: "Freelance",
  //   jobtitle: "Web Developer",
  //   startYear: "2022",
  //   endYear: "Present",
  //   details: "",
  // },
  {
    id: 3,
    company: "Nike",
    jobtitle: "Software Engineer 2",
    startYear: "Aug 2025",
    endYear: "Present",
    details: `● Built a mass-BOM edit capability enabling selection and instant preview of up to <b>60,000 BOMs</b> with <b>no perceptible lag</b> by using virtualization, incremental rendering, and optimized state management.
    <br/><br/>
    ● Standardized selection and editing flows with a reusable component library plus comprehensive client-side validation and error handling to prevent invalid submissions and simplify UX.
    <br/><br/>
    ● Designed an asynchronous bulk-update pipeline using <b>S3 presigned URLs</b> for uploads and background processing on <b>EKS, ECS, and Lambda</b>, moving heavy work off the UI thread and enabling reliable large-scale updates.
    <br/><br/>
    ● Implemented queuing, real-time status updates, safe retry/rollback paths, and integrated the feature into production workflows to increase operator throughput and reduce manual intervention.`,
  },
  {
    id: 2,
    company: "InspironLabs",
    jobtitle: "Software Engineer",
    startYear: "Feb 2023",
    endYear: "Aug 2025",
    details: `● <b>Enhanced an advanced SEO product</b>, integrating content creation and competitive content analysis, <b>leading to a 30% increase in search engine rankings</b>.
    <br/><br/>
    ● Utilized analytics tools to monitor and optimize website performance, <b>reducing load time by 20% and improving user engagement</b>.
    <br/><br/>
    ● Led the development of the Navigator from scratch for Optum, the largest healthcare product provider in the USA (UHC), <b>resulting in a 25% increase in user satisfaction.</b>
    <br/><br/>
    ● Employed agile methodologies to manage project timelines and deliverables, optimizing performance and creating an excellent user interface, <b>reducing user errors by 15%.</b>
    <br/><br/>
    ● <b>Managed a team of eight developers</b>, providing guidance and support to achieve project goals.Facilitated daily stand-ups, sprint planning, and retrospectives to maintain agile workflows.`,
  },
  {
    id: 1,
    company: "Snapdeal",
    jobtitle: "Software Engineer",
    startYear: "May 2022",
    endYear: "Feb 2023",
    details: `● Improved a real-time chat application to resolve customer order issues, <b>achieved an impressive quarterly expense reduction of 11 lakhs</b>, bolstering organizational profitability through migrating from a proprietary platform to open-source with 0 data loss.
    <br/><br/>
    ● Developed a metrics page for administrators to monitor average resolution and first response times for agent chats, including time range filters for improved analysis. <b>Improved efficiency by 40%</b> by eliminating dependency on external analytics tools, and streamlining the monitoring process.
    <br/><br/>
    ● Implemented a queue system for excess chats, with users receiving predefined waiting time messages, <b>resulting in a 25% increase in customer satisfaction and a 20% reduction in agent burnout.</b>
    <br/><br/>
    ● Developed a feature enabling administrators to set reminder messages and intervals, ensuring timely follow-ups with users. Implemented automatic chat resolution after the final reminder, <b>reducing unresolved tickets by 30% and increasing overall customer response rates by 20%.</b>`,
  },
];
